export const PLAN_DATE_FORMAT = 'Do MMM YYYY';
export const CANCELLATION_NOTES_FORM_NAME = 'planCancellationNotes';
export const NOTE_DISPLAY_FORM_NAME = 'noteDisplayForm';

export const CARS_FIELDS = [
  [
    'VRN',
    'carFirstRegistered',
    'annualMileage',
    'currentMileage',
    'lastServiceDate',
    'lastServiceMileage',
  ],
  [
    'VRN2',
    'VRN2CarFirstRegistered',
    'VRN2AnnualMileage',
    'VRN2CurrentMileage',
    'VRN2LastServiceDate',
    'VRN2LastServiceMileage',
  ],
];

export const CARS_FIELDS_MAP = {
  VRN2: 'VRN',
  VRN2CarFirstRegistered: 'carFirstRegistered',
  VRN2AnnualMileage: 'annualMileage',
  VRN2CurrentMileage: 'currentMileage',
  VRN2LastServiceDate: 'lastServiceDate',
  VRN2LastServiceMileage: 'lastServiceMileage',
};

export const PLAN_TABS = {
  ALL: 'allPlans',
  CANCELLED: 'cancelledPlans',
};

export const PLAN_TAB_TITLES = {
  [PLAN_TABS.ALL]: 'Search Plans',
  [PLAN_TABS.CANCELLED]: 'Cancelled Plans',
};
